<component
  v-if="shouldRenderConfig"
  v-bind:is="getContainerType"
  v-bind:class="getClassName"
>
  <appSelectOption
    v-for="(option,key) in getOptions"
    v-bind:key="key"
    v-bind:propsData="option"
    v-bind:selectId="'options_select_' + key"
    v-bind:optionType="optionsType"
  ></appSelectOption>
</component>
